import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import ProfileDesktop from '../components/faraaz/ProfileDesktop'
import ProfileMobile from '../components/faraaz/ProfileMobile'
import Riya from '../assets/images/Riya.jpg'

const MohamedElnagr = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
                <meta charSet="utf-8" />
                <title>Mohamed Elnagr - 800 Homes</title>
            </Helmet>

            <section id="website-responsive" className="d-none d-md-block">
                <ProfileDesktop
                    Image={Riya}
                    Title="Mohamed Elnagr"
                    Designation="Sales Director"
                    PhoneNumberLink="+971527308804"
                    PhoneNumber="+971 52 730 8804"
                    WhatsappLink="971527308804"
                    Whatsapp="+971 52 730 8804"
                    Email="Mohamed@800homes.ae"
                />
            </section>

            <section id="website-responsive" className="d-block d-md-none">
                <ProfileMobile
                    Image={Riya}
                    Title="Mohamed Elnagr"
                    Designation="Sales Director"
                    PhoneNumberLink="+971527308804"
                    PhoneNumber="+971 52 730 8804"
                    WhatsappLink="971527308804"
                    Whatsapp="+971 52 730 8804"
                    Email="Mohamed@800homes.ae"
                />
            </section>
        </>
    )
}

export default MohamedElnagr
